import React from "react";
import { connect } from "react-redux";
import { ArrowPathIcon } from "@heroicons/react/20/solid";
import { Actions as SMART_PENSION_ACTIONS } from "./store/smartPensionActions";
import { INTEGRATION_LOGO as Logo } from "./store/config";

const SmartPensionEmployeeLink = ({ agreement, disabled, resyncEmployee, resyncingEmployee, thirdPartyId }) => {
	return (
		<button
			disabled={disabled || resyncingEmployee || !thirdPartyId || ["desynced", "ignored"].includes(thirdPartyId)}
			className="btn btn-default"
			type="button"
			style={{ marginRight: 10 }}
			onClick={() => resyncEmployee(agreement)}
		>
			{resyncingEmployee ? (
				<ArrowPathIcon
					style={{ height: "1.5em", float: "left" }}
					className={`${resyncingEmployee ? "animate-spin" : ""}`}
				/>
			) : (
				<img
					src={Logo}
					style={{ height: "1.5em", float: "left" }}
				/>
			)}
			<div style={{ float: "left", marginLeft: 5 }}>Resync{resyncingEmployee ? "ing..." : null}</div>
		</button>
	);
};

const mapStateToProps = (state, ownProps) => {
	const agreement = state.employee.agreementInfo?.id;
	const agreementInfo = ownProps.agreementInfo ? ownProps.agreementInfo : state.employee.agreementInfo;

	const resyncingEmployee = state.integration?.pension?.smartPension?.resyncingEmployee;
	const thirdPartyId =
		state.employee?.smartPensionLink ||
		state?.integration?.pension?.smartPension?.links?.find?.((e) => e?.agreement == agreementInfo?.id)?.link;

	return {
		agreement,
		resyncingEmployee,
		thirdPartyId,
	};
};

const mapDispatchToProps = (dispatch) => ({
	resyncEmployee: (agreement) => dispatch(SMART_PENSION_ACTIONS.resyncEmployee(agreement)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SmartPensionEmployeeLink);
